import _toConsumableArray from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import * as React from 'react';
import { View, StyleSheet } from 'react-native';
import { polyfill } from 'react-lifecycles-compat'; // eslint-disable-next-line import/no-unresolved

import { ScreenContainer } from 'react-native-screens';
import createTabNavigator from '../utils/createTabNavigator';
import BottomTabBar from '../views/BottomTabBar';
import ResourceSavingScene from '../views/ResourceSavingScene';

var TabNavigationView =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(TabNavigationView, _React$PureComponent);

  function TabNavigationView() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TabNavigationView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TabNavigationView)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      loaded: [_this.props.navigation.state.index]
    });

    _defineProperty(_assertThisInitialized(_this), "_renderTabBar", function () {
      var _this$props = _this.props,
          _this$props$tabBarCom = _this$props.tabBarComponent,
          TabBarComponent = _this$props$tabBarCom === void 0 ? BottomTabBar : _this$props$tabBarCom,
          tabBarOptions = _this$props.tabBarOptions,
          navigation = _this$props.navigation,
          screenProps = _this$props.screenProps,
          getLabelText = _this$props.getLabelText,
          getAccessibilityLabel = _this$props.getAccessibilityLabel,
          getButtonComponent = _this$props.getButtonComponent,
          getAccessibilityRole = _this$props.getAccessibilityRole,
          getAccessibilityStates = _this$props.getAccessibilityStates,
          getTestID = _this$props.getTestID,
          renderIcon = _this$props.renderIcon,
          onTabPress = _this$props.onTabPress,
          onTabLongPress = _this$props.onTabLongPress;
      var descriptors = _this.props.descriptors;
      var state = _this.props.navigation.state;
      var route = state.routes[state.index];
      var descriptor = descriptors[route.key];
      var options = descriptor.options;

      if (options.tabBarVisible === false) {
        return null;
      }

      return React.createElement(TabBarComponent, _extends({}, tabBarOptions, {
        jumpTo: _this._jumpTo,
        navigation: navigation,
        screenProps: screenProps,
        onTabPress: onTabPress,
        onTabLongPress: onTabLongPress,
        getLabelText: getLabelText,
        getButtonComponent: getButtonComponent,
        getAccessibilityLabel: getAccessibilityLabel,
        getAccessibilityRole: getAccessibilityRole,
        getAccessibilityStates: getAccessibilityStates,
        getTestID: getTestID,
        renderIcon: renderIcon
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "_jumpTo", function (key) {
      var _this$props2 = _this.props,
          navigation = _this$props2.navigation,
          onIndexChange = _this$props2.onIndexChange;
      var index = navigation.state.routes.findIndex(function (route) {
        return route.key === key;
      });
      onIndexChange(index);
    });

    return _this;
  }

  _createClass(TabNavigationView, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          navigation = _this$props3.navigation,
          renderScene = _this$props3.renderScene,
          lazy = _this$props3.lazy;
      var routes = navigation.state.routes;
      var loaded = this.state.loaded;
      return React.createElement(View, {
        style: styles.container
      }, React.createElement(ScreenContainer, {
        style: styles.pages
      }, routes.map(function (route, index) {
        if (lazy && !loaded.includes(index)) {
          // Don't render a screen if we've never navigated to it
          return null;
        }

        var isFocused = navigation.state.index === index;
        return React.createElement(ResourceSavingScene, {
          key: route.key,
          style: StyleSheet.absoluteFill,
          isVisible: isFocused
        }, renderScene({
          route: route
        }));
      })), this._renderTabBar());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var index = nextProps.navigation.state.index;
      return {
        // Set the current tab to be loaded if it was not loaded before
        loaded: prevState.loaded.includes(index) ? prevState.loaded : [].concat(_toConsumableArray(prevState.loaded), [index])
      };
    }
  }]);

  return TabNavigationView;
}(React.PureComponent);

_defineProperty(TabNavigationView, "defaultProps", {
  lazy: true,
  getAccessibilityRole: function getAccessibilityRole() {
    return 'button';
  },
  getAccessibilityStates: function getAccessibilityStates(_ref) {
    var focused = _ref.focused;
    return focused ? ['selected'] : [];
  }
});

polyfill(TabNavigationView);
var styles = StyleSheet.create({
  container: {
    flex: 1,
    overflow: 'hidden'
  },
  pages: {
    flex: 1
  }
});
export default createTabNavigator(TabNavigationView);